import React, { useEffect, useRef, useState } from "react";
import styles from "./Popup.module.css";

type Trigger = "hover" | "click";

interface PopupProps {
  trigger?: Trigger;
  content: React.ReactNode;
  children: React.ReactNode;
}

const Popup: React.FC<PopupProps> = ({
  trigger = "hover",
  content,
  children,
}) => {
  const [visible, setVisible] = useState(false);
  const wrapperRef = useRef<HTMLDivElement>(null);

  const show = () => {
    setVisible(true);
  };
  const hide = () => {
    setVisible(false);
  };
  const toggle = () => {
    setVisible((prev) => !prev);
  };

  useEffect(() => {
    if (trigger !== "click" || !visible) return;

    const handleClickOutside = (event: MouseEvent) => {
      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(event.target as Node)
      ) {
        setVisible(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [visible, trigger]);

  return (
    <div
      className={styles.popupWrapper}
      ref={wrapperRef}
      {...(trigger === "hover"
        ? { onMouseEnter: show, onMouseLeave: hide }
        : {})}
    >
      <div
        className={styles.popupContainer}
        onClick={trigger === "click" ? toggle : undefined}
      >
        {children}
      </div>
      {visible && <div className={styles.popupContent}>{content}</div>}
    </div>
  );
};

export default Popup;
